import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  StepProgress,
  StepSlider,
  StepSliderItem,
  StepContent,
  StepContentBody,
  CalendarContainer,
  CalendarContainer2,
  CalendarContainer3,
  CalendarDay,
  CalendarDays,
  CalendarGrid,
  CalendarHeader,
  ConfirmButton,
  H3,
  MonthButton,
  MonthText,
  BackButton,
  Container,
  Container2,
  Container3,
  Container4,
  H2,
  Small,
  SubmitButton,
  TimeButton,
  Button,
  CheckboxContainer,
  Cont,
  FormContainer,
  FormMain,
  Input,
  InputCheckBox,
  Label,
  LabelSmall,
  OptionElement,
  SecondContainer,
  Select,
  PopUp,
  Second,
  CalendarGrid2,
  PolCheck,
  Div,
  StepProgress0,
  X2,
  NoFree,
} from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../store";
import { getDays } from "../../../store/slices/daysSlice";
import { postOrder } from "../../../store/slices/postOrderSlice";
import { getTime } from "../../../store/slices/timeSlice";
import Thanks from "../Thanks/Thanks";
import { getProductCategories } from "../../../store/slices/productCategoriesSlice";
import FormattedDate, { formatDate } from "../DateFormat/FormattedDate";
import { getProducts } from "../../../store/slices/productsSlice";

export const BookingPopup = () => {
  const calendarRef = useRef<HTMLDivElement | null>(null);
  const timeSelectorRef = useRef<HTMLDivElement | null>(null);
  const formRef = useRef<HTMLDivElement | null>(null);
  const refRef = useRef<HTMLDivElement | null>(null);
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const cardRef = useRef<HTMLDivElement | null>(null);

  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const [step, setStep] = useState(0);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [selectedTime, setSelectedTime] = useState<string | null>(null);
  const [errors, setErrors] = useState({
    service: "",
    phone: "",
    telegram: "",
    email: "",
    isAgreed: "",
  });
  const [service, setService] = useState("");
  const [selectedServiceId, setSelectedServiceId] = useState<number | null>(
    null
  );
  const [phone, setPhone] = useState("");
  const [telegram, setTelegram] = useState("");
  const [email, setEmail] = useState("");
  const [isAgreed, setIsAgreed] = useState(false);

  useEffect(() => {
    dispatch(getProducts());
    dispatch(getDays());
  }, [dispatch]);

  const services = useSelector(
    (state: RootState) => state.productCategories.productCategories
  );

  console.log("services", services);

  const totalSteps = 3;

  const { dates, loading, error } = useSelector(
    (state: RootState) => state.days
  );
  console.log("days:", dates);
  const { time } = useSelector((state: RootState) => state.time);
  console.log("Redux time state:", time);
  const handleDaySelect = (day: number) => {
    const newSelectedDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      day
    );

    newSelectedDate.setHours(0, 0, 0, 0);

    setSelectedDate(newSelectedDate);
  };
  useEffect(() => {
    if (selectedDate) {
      console.log(
        "Fetching time slots for:",
        selectedDate.toISOString().split("T")[0]
      );
      dispatch(getTime(selectedDate.toISOString().split("T")[0]));
    }
  }, [dispatch, selectedDate]);
  useEffect(() => {
    console.log("Обновился selectedServiceId:", selectedServiceId);
  }, [selectedServiceId]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  const disabledDays =
    dates && Array.isArray(dates) && dates[0]?.dates
      ? dates[0].dates.map((dateString) => new Date(dateString).getDate() - 1)
      : [];

  const weekendDays = [];
  const getDaysInMonth = () => {
    return new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    ).getDate();
  };

  for (let day = 0; day <= getDaysInMonth(); day++) {
    const currentDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      day
    );
    const dayOfWeek = currentDay.getDay();
    if (dayOfWeek === 0 || dayOfWeek === 6) {
      weekendDays.push(day);
    }
  }

  const allDisabledDays = [...disabledDays, ...weekendDays];

  const handleMonthChange = (increment: number) => {
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setMonth(newDate.getMonth() + increment);

      // Если новый месяц имеет меньше дней, чем текущий день в месяце,
      // устанавливаем день в 1-е число, чтобы избежать "перепрыгивания".
      if (newDate.getDate() !== prevDate.getDate()) {
        newDate.setDate(0);
      }

      return newDate;
    });
  };

  const isDaySelected = (day: number) => {
    return (
      selectedDate &&
      selectedDate.getDate() === day &&
      selectedDate.getMonth() === currentDate.getMonth() &&
      selectedDate.getFullYear() === currentDate.getFullYear()
    );
  };

  const getFirstDayOfMonth = () => {
    return new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    ).getDay();
  };

  const weekDays = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"];

  const ShowCalendar = () => {
    if (calendarRef.current && timeSelectorRef.current) {
      calendarRef.current.style.display = "block";
      timeSelectorRef.current.style.display = "none";
    }
    setStep(step - 1);
  };

  const ShowTime = () => {
    if (calendarRef.current && timeSelectorRef.current) {
      calendarRef.current.style.display = "none";
      timeSelectorRef.current.style.display = "block";
      setStep(step + 1);
    }
  };

  const ShowTimeBack = () => {
    if (calendarRef.current && timeSelectorRef.current) {
      calendarRef.current.style.display = "none";
      timeSelectorRef.current.style.display = "block";
      formRef.current.style.display = "none";
      setStep(step - 1);
    }
  };

  const ShowForm = () => {
    if (timeSelectorRef.current && formRef.current) {
      timeSelectorRef.current.style.display = "none";
      formRef.current.style.display = "block";
      setStep(step + 1);
    }
  };

  const isValidEmail = (email: string) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const isValidPhone = (phone: string) => {
    const re = /^8\d{3}\d{3}\d{2}\d{2}$/;
    return re.test(phone);
  };

  const isValidTelegram = (telegram: string) => {
    const re = /^@\w+$/;
    return re.test(telegram);
  };

  const handleAgreedChange = () => {
    setIsAgreed(!isAgreed);
    setErrors((prev) => ({
      ...prev,
      isAgreed: !isAgreed ? "" : prev.isAgreed,
    }));
  };

  const validateInputs = () => {
    const newErrors = {
      service: "",
      phone: "",
      telegram: "",
      email: "",
      isAgreed: "",
    };

    if (!service) {
      newErrors.service = "Услуга обязательна";
    }
    if (!phone) {
      newErrors.phone = "Номер телефона обязателен";
    } else if (!isValidPhone(phone)) {
      newErrors.phone = "Не корректный номер. Например: 89871234560";
    }

    if (!telegram) {
      newErrors.telegram = "Телеграм обязателен";
    } else if (!isValidTelegram(telegram)) {
      newErrors.telegram = "Не корректный ник Telegram. Например: @username";
    }

    if (!email) {
      newErrors.email = "E-mail обязателен";
    } else if (!isValidEmail(email)) {
      newErrors.email = "Не корректный e-mail. Например: example@gmail.com";
    }

    if (!isAgreed) {
      newErrors.isAgreed =
        "Вы должны согласиться с Политикой конфиденциальности.";
    }

    const hasErrors = Object.values(newErrors).some((error) => error !== "");
    if (hasErrors) {
      setErrors(newErrors);
    }

    return !hasErrors;
  };

  const ShowThanks = async () => {
    const isValid = validateInputs();
    if (isValid) {
      const orderData = {
        consultation_date: selectedDate
          ? selectedDate.toISOString().split("T")[0]
          : "",
        consultation_time: selectedTime,
        username: "Произвольное имя",
        product: {
          id: selectedServiceId,
        },
        is_booked: false,
        is_completed: false,
        question: service,
        telephone: phone,
        telegram: telegram,
        email: email,
        linkedin_url: "",
      };
      console.log("orderData: ", orderData);
      await dispatch(postOrder(orderData));

      if (
        calendarRef.current &&
        timeSelectorRef.current &&
        formRef.current &&
        wrapperRef.current &&
        cardRef.current
      ) {
        calendarRef.current.style.display = "none";
        timeSelectorRef.current.style.display = "none";
        formRef.current.style.display = "none";
        cardRef.current.style.display = "none";
        wrapperRef.current.style.display = "block";
      }
    } else {
      console.log("Некорректные данные, пожалуйста, проверьте их.");
    }
  };
  console.log("selectedServiceId перед отправкой:", selectedServiceId);
  const HidePopUp = () => {
    refRef.current.style.display = "none";
  };
  return (
    <PopUp ref={refRef}>
      <Card ref={cardRef}>
        <StepProgress0>
          <StepProgress>
            <X2 onClick={HidePopUp} $img={require("./X.jpg")} />
            <StepSlider>
              {[...Array(totalSteps)].map((_, index) => (
                <StepSliderItem key={index} $isActive={index <= step}>
                  <Second $isActive={index <= step}>{index + 1}</Second>
                </StepSliderItem>
              ))}
            </StepSlider>
            <StepContent>
              <StepContentBody className={step === 0 ? "" : "out"}>
                Выбор даты
              </StepContentBody>
              <StepContentBody className={step === 1 ? "" : "out"}>
                Выбор времени
              </StepContentBody>
              <StepContentBody className={step === 2 ? "" : "out"}>
                Контактные данные
              </StepContentBody>
            </StepContent>
          </StepProgress>
        </StepProgress0>
      </Card>
      <CalendarContainer2 ref={calendarRef}>
        <CalendarContainer>
          <CalendarContainer3>
            <H3>Выберете свободную дату</H3>
            <CalendarGrid2>
              <CalendarHeader>
                <MonthButton onClick={() => handleMonthChange(-1)}>
                  {"<"}
                </MonthButton>
                <MonthText>
                  {currentDate.toLocaleString("default", { month: "long" })}
                  {currentDate.getFullYear()}
                </MonthText>
                <MonthButton onClick={() => handleMonthChange(1)}>
                  {">"}
                </MonthButton>
              </CalendarHeader>
              <CalendarDays>
                {weekDays.map((day, index) => (
                  <div key={index}>{day}</div>
                ))}
              </CalendarDays>
              <CalendarGrid>
                {[
                  ...Array(
                    getFirstDayOfMonth() === 0 ? 6 : getFirstDayOfMonth() - 1
                  ),
                ].map((_, index) => (
                  <CalendarDay key={index} />
                ))}
                {[...Array(getDaysInMonth())].map((_, index) => {
                  const day = index + 1;
                  const isPastDate =
                    new Date(
                      currentDate.getFullYear(),
                      currentDate.getMonth(),
                      day
                    ) < new Date();
                  const isDisabledDate = allDisabledDays.includes(day);
                  return (
                    <CalendarDay
                      key={day}
                      onClick={() => {
                        if (!isPastDate && !isDisabledDate) {
                          handleDaySelect(day);
                        }
                      }}
                      selected={isDaySelected(day)}
                      isPast={isPastDate}
                      disabled={isDisabledDate}
                    >
                      {day}
                    </CalendarDay>
                  );
                })}
              </CalendarGrid>
              <ConfirmButton
                onClick={ShowTime}
                disabled={!selectedDate}
                type="button"
                name="next"
              >
                Далее
              </ConfirmButton>
            </CalendarGrid2>
          </CalendarContainer3>
        </CalendarContainer>
      </CalendarContainer2>
      <Container3 ref={timeSelectorRef}>
        <Container>
          <Container4>
            <H2>Выберете свободное время</H2>
            <Small>*время московское</Small>
            <Container2>
              {time && time.length > 0 ? (
                time.map((timeItem, index) => (
                  <TimeButton
                    key={index}
                    selected={selectedTime === timeItem}
                    onClick={() => {
                      setSelectedTime(timeItem);
                    }}
                  >
                    {timeItem}
                  </TimeButton>
                ))
              ) : (
                <NoFree>Свободных слотов нет</NoFree>
              )}
            </Container2>
            <Container2>
              <BackButton onClick={ShowCalendar}>Назад</BackButton>
              <SubmitButton
                onClick={ShowForm}
                disabled={!selectedTime}
                type="button"
                name="next"
              >
                Подтвердить
              </SubmitButton>
            </Container2>
          </Container4>
        </Container>
      </Container3>
      <FormContainer ref={formRef}>
        <SecondContainer>
          <FormMain>
            <Cont>
              <Label>Услуга*</Label>
              <Select
                value={service}
                onChange={(e) => {
                  const selectedService = services.find(
                    (s) => s.title === e.target.value
                  );
                  setService(e.target.value);
                  setSelectedServiceId(
                    selectedService ? selectedService.id : null
                  );
                  console.log("Выбранная услуга:", selectedService);
                  console.log("selectedServiceId:", selectedServiceId);
                }}
              >
                <OptionElement value="">Выберите услугу</OptionElement>
                {services.map((s) => (
                  <OptionElement key={s.id} value={s.title}>
                    {s.title}
                  </OptionElement>
                ))}
              </Select>
              <Div className="error">{errors.service}</Div>
            </Cont>
            <Cont>
              <Label>Номер телефона*</Label>
              <Input
                type="tel"
                placeholder="+7 (999) 999-99-99"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <Div className="error">{errors.phone}</Div>
            </Cont>
            <Cont>
              <Label>Телеграм*</Label>
              <Input
                type="text"
                placeholder="@example"
                value={telegram}
                onChange={(e) => setTelegram(e.target.value)}
              />
              <Div className="error">{errors.telegram}</Div>
            </Cont>
            <Cont>
              <Label>E-mail*</Label>
              <Input
                type="email"
                placeholder="Введите ваш e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Div className="error">{errors.email}</Div>
            </Cont>
            <CheckboxContainer>
              <InputCheckBox
                type="checkbox"
                checked={isAgreed}
                onChange={handleAgreedChange}
              />
              <LabelSmall>
                ⁠​‌‍‎ Нажимая «Отправить», вы соглашаетесь с
                <PolCheck href="/policy">
                  ⁠​‌‍‎ Политикой конфиденциальности
                </PolCheck>
                .
              </LabelSmall>
            </CheckboxContainer>
            <Button onClick={ShowTimeBack}>Назад</Button>
            <ConfirmButton
              onClick={ShowThanks}
              type="button"
              name="finish"
              disabled={!validateInputs}
            >
              Отправить
            </ConfirmButton>
          </FormMain>
        </SecondContainer>
      </FormContainer>
      <Thanks
        ref={wrapperRef}
        time={selectedTime}
        date={selectedDate ? selectedDate.toISOString().split("T")[0] : null}
      />
    </PopUp>
  );
};
